(function () {
  /**
   * Energy badge modal — custom open/close (no Dawn ModalDialog web component).
   *
   * Using a plain <div> instead of <modal-dialog> avoids Dawn's connectedCallback
   * moving modals to document.body, which caused duplicate-ID conflicts when the
   * same product appears in multiple sections (collection grid + recommendations).
   *
   * Listeners (all delegated, so they work for AJAX-rendered cart content):
   *   1. [data-modal][data-tab-index] click  → open modal + switch to tab
   *   2. [data-lepro-modal-close] click      → close active modal
   *   3. Backdrop click (modal div itself)   → close active modal
   *   4. Escape key                          → close active modal
   *   5. .energy-efficiency-tab-content li   → switch tab inside open modal
   *
   * Also handles the PDP modal (#PopupModal-energy-efficiency) which still uses
   * the Dawn ModalDialog web component — falls back to modal.show() when available.
   */

  var activeModal = null;
  var activeOpener = null;

  /* ── Tab switching helper ── */
  function switchTab(modal, tabIndex) {
    var container = modal.querySelector('.energy-header-body');
    if (!container) return;
    var tabs = container.querySelectorAll('.energy-efficiency-tab-content li');
    var wraps = container.querySelectorAll('.energy-wrap');
    tabs.forEach(function (t) { t.classList.remove('active'); });
    if (tabs[tabIndex]) tabs[tabIndex].classList.add('active');
    wraps.forEach(function (w, j) {
      w.style.display = j === tabIndex ? 'block' : 'none';
    });
    /* Lazy-load iframe: only set src when the PDF tab becomes visible */
    if (tabIndex === 1) {
      var iframe = container.querySelector('.lepro-energy-modal__iframe[data-src]');
      if (iframe) {
        iframe.src = iframe.dataset.src;
        iframe.removeAttribute('data-src');
      }
    }
  }

  /* ── Open our custom div modal ── */
  function openCustomModal(modal, opener, tabIndex) {
    if (activeModal && activeModal !== modal) closeModal(false);
    activeModal = modal;
    activeOpener = opener;

    /* Move to body so position:fixed works even inside transformed ancestors */
    if (modal.parentElement !== document.body) {
      /* Evict any stale same-ID modal left in body after AJAX cart re-renders */
      if (modal.id) {
        var stale = document.body.querySelector('#' + modal.id);
        if (stale && stale !== modal) document.body.removeChild(stale);
      }
      modal._leproOriginalParent = modal.parentElement;
      document.body.appendChild(modal);
    }

    modal.setAttribute('open', '');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');

    switchTab(modal, tabIndex);

    var dialog = modal.querySelector('[role="dialog"]');
    if (dialog) {
      setTimeout(function () { dialog.focus(); }, 0);
    }
  }

  /* ── Close active modal ── */
  function closeModal(returnFocus) {
    if (!activeModal) return;
    activeModal.removeAttribute('open');
    activeModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    if (returnFocus !== false && activeOpener) {
      activeOpener.focus();
    }
    /* Return modal to its original parent to prevent DOM accumulation in body */
    var orig = activeModal._leproOriginalParent;
    if (orig && orig.isConnected) {
      orig.appendChild(activeModal);
      activeModal._leproOriginalParent = null;
    }
    activeModal = null;
    activeOpener = null;
  }

  /* ── 1. Badge button → open modal + switch tab ── */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-modal][data-tab-index]');
    if (!trigger) return;

    var modalSelector = trigger.dataset.modal;
    var tabIndex = parseInt(trigger.dataset.tabIndex, 10);

    /* Find modal: prefer sibling within .lepro-energy-badge (not yet moved to body),
       fall back to document-wide search by ID. */
    var badge = trigger.closest('.lepro-energy-badge');
    var modal = (badge && badge.querySelector('.lepro-energy-modal')) ||
                document.querySelector(modalSelector);

    if (!modal) return;

    /* PDP modal still uses Dawn ModalDialog web component — delegate to show() */
    if (typeof modal.show === 'function') {
      modal.show(trigger);
      switchTab(modal, tabIndex);
      return;
    }

    /* Our custom div modal */
    openCustomModal(modal, trigger, tabIndex);
  });

  /* ── 2 & 3. Close button or backdrop click ── */
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-lepro-modal-close]')) {
      closeModal();
      return;
    }
    /* Backdrop: click landed directly on the modal overlay div */
    if (activeModal && event.target === activeModal) {
      closeModal();
    }
  });

  /* ── 4. Escape key ── */
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' && activeModal) closeModal();
  });

  /* ── 5. Tab click inside open modal ── */
  document.addEventListener('click', function (event) {
    var li = event.target.closest('.energy-efficiency-tab-content li');
    if (!li) return;
    var container = li.closest('.energy-header-body');
    if (!container) return;
    var tabs = container.querySelectorAll('.energy-efficiency-tab-content li');
    var index = Array.prototype.indexOf.call(tabs, li);
    /* Delegate to switchTab so iframe lazy-load is also triggered */
    var modal = li.closest('.lepro-energy-modal') || li.closest('modal-dialog') || activeModal;
    if (modal) {
      switchTab(modal, index);
    }
  });
})();
